/* istanbul ignore file */
import type { MicroAppExport } from './microAppTypes'

export type AsType<T> = (value: T) => T

export const asType = <T>(value: T) => value
export const asMicroApp = asType as AsType<MicroAppExport>
